/* import __COLOCATED_TEMPLATE__ from './addon-info-tooltip.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */

import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';

interface Signature {
  Args: {
    title: string;
    content: string;
    articleId?: number;
    articleLinkText?: string;
    trackEventName?: string;
    showOn: ('click' | 'mouseenter')[];
    hideOn: ('click' | 'clickout' | 'mouseleave')[];
  };
  Blocks: {
    default: [];
  };
}

export default class AddonInfoTooltipComponent extends Component<Signature> {
  @service declare purchaseAnalyticsService: any;

  @action onShow() {
    this.trackEvent('show', 'addon_info_tooltip');
  }

  @action onHide() {
    this.trackEvent('hide', 'addon_info_tooltip');
  }

  trackEvent(action: string, context: string) {
    this.purchaseAnalyticsService.trackEvent({
      action,
      context,
      place: 'update_subscription',
      object: this.args.trackEventName,
    });
  }

  trackArticleLinkClick() {
    this.trackEvent('clicked', 'addon_info_tooltip_article');
  }

  get articleLink() {
    return `https://intercom.com/help/articles/${this.args.articleId}`;
  }

  @action
  handleArticleLinkClick(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.trackArticleLinkClick();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Billing::UpdateEarlyStageSubscription::AddonInfoTooltip': typeof AddonInfoTooltipComponent;
    'billing/update-early-stage-subscription/addon-info-tooltip': typeof AddonInfoTooltipComponent;
  }
}
